import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { DxListComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import 'devextreme/data/odata/store';

// TODO MK-REF
@Component({
  selector: 'baf-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.css']
})
export class ProfileViewComponent implements OnInit {
  @ViewChildren(DxListComponent)
  list: QueryList<DxListComponent>;

  isPopupVisible = true;
  listDataSource2 = ['Profil 7', 'Profil 8'];

  updateContentTimer: number;
  scrollByContent = true;
  scrollByThumb = true;
  scrollbarMode: string;
  pullDown = false;

  listDataSource = new DataSource({
    store: {
      type: 'odata',
      url: 'http://localhost/WebAPI/user/GetData',
      key: 'id'
    },
    paginate: true,
    pageSize: 5
  });

  constructor() {}

  addItem() {
    const selectedKeys = this.list.toArray()[0].instance.option('selectedItemKeys');
    selectedKeys.forEach(element => {
      this.listDataSource2.push(element);
    });
    this.list.toArray()[0].instance.reload();
    this.list.toArray()[1].instance.reload();
  }

  removeItem() {
    const selectedKeys = this.list.toArray()[0].instance.option('selectedItemKeys');
    const selectedKeys2 = this.list.toArray()[1].instance.option('selectedItemKeys');
    selectedKeys2.forEach(element => {
      const index: number = this.listDataSource2.indexOf(element);
      if (index !== -1) {
        this.listDataSource2.splice(index, 1);
      }
    });
    this.list.toArray()[0].instance.reload();
    this.list.toArray()[1].instance.reload();
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/profile-view/profile-view.component.ts